module.exports = __webpack_public_path__ + "images/backgrounds/purty_wood_dark.7a14a57fef9435b0def0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/purty_wood_dark.png
// module id = 8kz3
// module chunks = 12